import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

/**
 * Button that can show a upload percentage and can be used for uploading data to a server.
 */
@Component({
    selector: 'app-upload-button',
    templateUrl: './upload-button.component.html',
    styleUrls: [],
    standalone: false
})
export class UploadButtonComponent implements OnChanges, OnInit {
  /**
   * Default label for the button if no upload is running
   */
  @Input() label: string;

  /**
   * additional classes for the component
   */
  @Input() class: string = null;

  /**
   * toggle for disable/enable the button
   */
  @Input() disabled: boolean = false;

  /**
   * upload Percentage. Oly set this if there is an uplaod running, otherwise set to null
   */
  @Input() uploadPercentage: number = null;

  /**
   * holds the initial label to switch back after upload
   */
  initialLabel: string;

  /**
   * @inheritDoc
   * changes the button label while the upload is running
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.hasOwnProperty('uploadPercentage') && changes.uploadPercentage.firstChange === false) {
      if(changes.uploadPercentage.currentValue === null) {
        // no upload running, show the default label
        this.label = this.initialLabel;
      }
      else {
        // upload is running, show the upload text
        this.label = 'input.upload-button.upload';
      }
    }
  }

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.initialLabel = this.label;
  }
}
